import {useToast} from "hooks";
import {useEffect} from "react";
import {messaging, onMessage} from "./index";
import {isSupported} from "firebase/messaging";

export const useNotificationListener = () => {
    useEffect(() => {
        let unsubscribe;

        const init = async () => {
            const supported = await isSupported();
            if (
                !supported ||
                !("Notification" in window) ||
                !("serviceWorker" in navigator) ||
                !("PushManager" in window) ||
                !messaging
            ) {
                return;
            }

            unsubscribe = onMessage(messaging, (payload) => {
                useToast(
                    "info",
                    payload.notification?.title || "You got a new notification"
                );
            });
        };

        init();

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, []);
};
